import { useState } from "react";

export function youtubeId(url = "") {
    const m = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{6,})/);
    return m ? m[1] : null;
}

export function vimeoId(url = "") {
    const m = url.match(/vimeo\.com\/(\d+)/);
    return m ? m[1] : null;
}

export function mediaKind(url = "") {
    if (!url) return "none";
    if (youtubeId(url)) return "youtube";
    if (vimeoId(url)) return "vimeo";
    return "video";
}

export default function HeroMedia({ url, poster, className = "", autoplay = true }) {
    const [failed, setFailed] = useState(false);
    const kind = mediaKind(url);

    if (failed || kind === "none") {
        return poster ? <img src={poster} alt="" className={className} /> : <div className={`${className} bg-[#0A0A0A]`} />;
    }
    if (kind === "youtube") {
        const id = youtubeId(url);
        if (!autoplay) {
            return (
                <div className={className}>
                    <iframe
                        title="video"
                        src={`https://www.youtube.com/embed/${id}?rel=0`}
                        allow="encrypted-media; fullscreen; picture-in-picture"
                        frameBorder="0"
                        allowFullScreen
                        className="absolute inset-0 h-full w-full"
                    />
                </div>
            );
        }
        return (
            <div className={`${className} overflow-hidden`}>
                <iframe
                    title="video"
                    src={`https://www.youtube.com/embed/${id}?autoplay=1&mute=1&loop=1&playlist=${id}&controls=0&playsinline=1&modestbranding=1&rel=0`}
                    allow="autoplay; encrypted-media; fullscreen"
                    frameBorder="0"
                    className="absolute left-1/2 top-1/2 h-[56.25vw] min-h-full w-[100vw] min-w-[177.78vh] -translate-x-1/2 -translate-y-1/2 pointer-events-none"
                />
            </div>
        );
    }
    if (kind === "vimeo") {
        const id = vimeoId(url);
        if (!autoplay) {
            return (
                <div className={className}>
                    <iframe
                        title="video"
                        src={`https://player.vimeo.com/video/${id}`}
                        allow="encrypted-media; fullscreen; picture-in-picture"
                        frameBorder="0"
                        allowFullScreen
                        className="absolute inset-0 h-full w-full"
                    />
                </div>
            );
        }
        return (
            <div className={`${className} overflow-hidden`}>
                <iframe
                    title="video"
                    src={`https://player.vimeo.com/video/${id}?autoplay=1&muted=1&loop=1&background=1&playsinline=1`}
                    allow="autoplay; encrypted-media; fullscreen"
                    frameBorder="0"
                    className="absolute left-1/2 top-1/2 h-[56.25vw] min-h-full w-[100vw] min-w-[177.78vh] -translate-x-1/2 -translate-y-1/2 pointer-events-none"
                />
            </div>
        );
    }
    return (
        <video
            autoPlay={autoplay}
            muted
            loop
            playsInline
            poster={poster || undefined}
            onError={() => setFailed(true)}
            className={className}
        >
            <source src={url} type="video/mp4" />
        </video>
    );
}
